<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title" v-if="!isVisualizacao && professorEdicao">Editar professor</h5>
      <h5 class="modal-title" v-if="!isVisualizacao && !professorEdicao">Cadastrar professor</h5>
      <h5 class="modal-title" v-if="isVisualizacao">Visualizar professor</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <fieldset :disabled="isVisualizacao">
      <div  class="row" v-if="professor.imagem_url != null && isVisualizacao">
        <div class="col-12" align="center">
          <img :src="obterUrlS3(professor.imagem_url)"
          alt="" class="rounded-circle">
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <form-group id="nome" label="Nome *" :text="{ required: 'Obrigatório informar o nome' }" :field="$v.professor.professor">
            <input type="text" class="form-control" id="nome" v-model="professor.professor"/>
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <form-group id="atividade" label="Atividade" :field="professor.atividade  || ''">
            <input type="text" class="form-control" id="atividade" v-model="professor.atividade"/>
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <form-group id="atividade" label="Foto" :field="professor.imagem_url || ''">
              <b-form-file
                v-model="professor.imagem_url"
                placeholder="Escolha uma imagem"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="image/jpeg, image/png"
              ></b-form-file>
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <form-group id="curriculo" label="Curriculo" :field="professor.curriculo  || ''">
            <textarea class="form-control" id="curriculo" rows="3" v-model="professor.curriculo"></textarea>
          </form-group>
        </div>
      </div>
      </fieldset>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" v-if="!isVisualizacao" @click="salvarProfessor">Salvar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')" v-if="isVisualizacao">Fechar</a>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')" v-else >Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import ProfessorAPI from '@/api/professor-api'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import UrlUtils from '@/core/util/url-utils'

export default {
  name: 'ModalCadastroProfessor',
  components: {
    FormGroup
  },

  props: {
    professorEdicao: Object,
    visualizar: Boolean
  },

  data () {
    return {
      professor: {
        professor: '',
        atividade: '',
        curriculo: ''
      }
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      if (this.professorEdicao) {
        this.professor = Object.assign({}, this.professorEdicao)
      } else {
        this.professor = {
          professor: '',
          atividade: '',
          curriculo: ''
        }
      }
    })
  },

  computed: {
    isVisualizacao: function () {
      return this.visualizar
    }
  },

  validations: {
    professor: {
      professor: { required },
      imagem_url: { },
      atividade: { },
      tipo_funcao_id: { }
    }
  },

  methods: {
    obterUrlS3: function (imagem) {
      return UrlUtils.obterUrlS3('professor/' + imagem)
    },

    show: function () {
      this.$bvModal.show('modal-cadastrar')
    },

    salvarProfessor: function () {
      this.$v.professor.$touch()
      if (!this.$v.professor.$invalid) {
        const loader = this.$loading.show()
        if (this.professorEdicao) {
          ProfessorAPI.editar(this.professor, this.professor.id).then(data => {
            loader.hide()

            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Professor editado com sucesso'
            }).then(() => {
              this.$bvModal.hide('modal-cadastrar')
              this.$emit('professorSalvo', this.professor)
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        } else {
          ProfessorAPI.cadastrar(this.professor).then(data => {
            loader.hide()

            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Professor cadastrado com sucesso'
            }).then(() => {
              this.$bvModal.hide('modal-cadastrar')
              this.$emit('professorSalvo', this.professor)
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      }
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
